import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=3fac8f02&scoped=true&lang=pug&"
import script from "./Agenda.vue?vue&type=script&lang=js&"
export * from "./Agenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac8f02",
  null
  
)

export default component.exports